<template>
  <div class="steps flex justify-between" :class="{ 'pt-6 mt-2 md:mt-4': hasTitle }">
    <template v-for="(step, index) in steps">
      <div
        :key="`${step.icon}-${index}-circle`"
        :data-qa="`signup-status-step-${index + 1}`"
        class="circle"
        :class="{ done: index + 1 <= activeStep }"
      >
        <span v-if="step.title" class="badge" v-text="step.title" />
        <OSvg :svg="step.icon" class="icon" />
      </div>
      <div v-if="index !== steps.length - 1" :key="`${step.icon}-${index}-line`" class="line" :class="{ done: index + 1 < activeStep }" />
    </template>
  </div>
</template>

<script>
const OSvg = () => import('@/components/OSvg')

export const props = {
  steps: {
    type: Array,
    required: false,
    default: () => ([]),
    validator: (steps) => {
      return steps.every(step => ['icon'].every(property => step.hasOwnProperty(property)))
    }
  },
  activeStep: {
    type: Number,
    default: 0
  }
}

export default {
  name: 'Steps',
  components: {
    OSvg
  },
  props,
  computed: {
    hasTitle () {
      return this.steps.some(step => !!step.title)
    }
  }
}
</script>

<style lang="postcss" scoped>
.steps {
  .badge {
    @apply bg-orange-300 text-white rounded-md absolute;
    top: -3rem;
    padding: 0.35rem 1.27rem;

    &:before {
      @apply h-2 w-2 absolute bg-orange-300 left-0 right-0 mr-auto ml-auto;
      border-radius: 0.1rem;
      transform: rotate(45deg);
      content: "";
      bottom: -0.4rem;
    }
  }

  .circle {
    @apply rounded-full flex relative justify-center items-center bg-gray-200 w-10 h-10 z-10 transition-all ease-in duration-300;

    .icon {
      @apply h-5 w-auto fill-gray-400 transition-all ease-in duration-300;
    }

  }

  .circle.done {
    @apply bg-green-300 transition-all ease-in duration-300;

    .icon {
      @apply fill-white transition-all ease-in duration-300;
    }
  }

  .line {
    @apply relative flex-1 flex items-center justify-center;

    &::after {
      @apply h-1 absolute bg-gray-200 transition-all ease-in duration-300;
      width: 110%;
      content: "";
    }

    &.done::after {
      @apply bg-green-300 transition-all ease-in duration-300;
    }
  }
}

@screen md {
  .steps {
    .badge {
      font-size: 1.6rem;
      top: -4rem;
    }

    .icon {
      @apply h-6;
    }
  }
}
</style>
